import { NgModule } from '@angular/core';
import { RouterModule, Route } from '@angular/router';
import { SharedModule } from '../shared/shared.module';

import { ShellComponent } from './shell.component';
import { UserDetailsComponent } from './user-details.component';
import { UserSettingsComponent } from './user-settings.component';
import { MainMenuComponent } from './main-menu.component';

import { MainMenuService } from './main-menu.service';
import { SystemTableMenuService } from './system-table-menu.service';

@NgModule({
	imports: [SharedModule, RouterModule],
	providers: [
		MainMenuService, SystemTableMenuService
	],
	declarations: [ShellComponent, UserSettingsComponent, UserDetailsComponent, MainMenuComponent],
	exports: [ShellComponent]
})
export class ShellModule { }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shell/shell.module.ts